
import React from "react";
import SiteDetailPage from "@/components/sites/SiteDetailPage";

const LescoutRecyclage = () => {
  const services = [
    "Location de bennes",
    "Recyclage des métaux",
    "Achat fer et métaux",
    "Évacuation déchets",
    "Services aux professionnels",
    "Services aux particuliers"
  ];

  return (
    <SiteDetailPage
      title="Lescout Recyclage - Location Bennes & Recyclage Métaux Lescout (81110)"
      description="Lescout Recyclage à Lescout - Spécialiste de la location de bennes, recyclage et achat de fer et métaux dans le Tarn. Services professionnels et particuliers."
      proximityInfo="Centre de recyclage au cœur du Tarn, spécialisé dans la location de bennes, l'achat de fer et métaux, et les solutions d'évacuation pour professionnels et particuliers."
      address="484 Chemin des Vignes"
      postalCode="81110"
      city="Lescout"
      phone="04.66.49.12.34"
      email="contactgfe@groupefabre.com"
      website="https://lescout-recyclage.fr/"
      services={services}
      coordinates={{ lat: 43.7102, lng: 2.1580 }}
      isMiniSite={true}
    />
  );
};

export default LescoutRecyclage;
